import(/* webpackMode: "eager" */ "/vercel/path0/app/fund/page.tsx");
